/**
 * 详情页 - 模板路由入口
 * 
 * 根据用户选择的模板ID，加载对应版本的详情页组件
 */

import { useTemplate } from "@/context/TemplateContext";

// ============================================
// 导入各模板组件
// ============================================

import ClassicListingDetail from "@/templates/classic/listing-detail/ListingDetail";
import ModernListingDetail from "@/templates/modern/listing-detail/ListingDetail";
import DarkListingDetail from "@/templates/dark/listing-detail/ListingDetail";
import GreenListingDetail from "@/templates/green/listing-detail/ListingDetail";
import RedListingDetail from "@/templates/red/listing-detail/ListingDetail";
import TechBlueListingDetail from "@/templates/tech-blue/listing-detail/ListingDetail";
import DeepBlueListingDetail from "@/templates/deep-blue/listing-detail/ListingDetail";
import TealListingDetail from "@/templates/teal/listing-detail/ListingDetail";
import SunsetListingDetail from "@/templates/sunset/listing-detail/ListingDetail";
import PurpleListingDetail from "@/templates/purple/listing-detail/ListingDetail";

// ============================================
// 模板映射表
// ============================================

const templateComponents = {
  classic: ClassicListingDetail,
  modern: ModernListingDetail,
  dark: DarkListingDetail,
  green: GreenListingDetail,
  red: RedListingDetail,
  "tech-blue": TechBlueListingDetail,
  "deep-blue": DeepBlueListingDetail,
  teal: TealListingDetail,
  sunset: SunsetListingDetail,
  purple: PurpleListingDetail,
};

// ============================================
// 详情页组件
// ============================================

export default function ListingDetail() {
  const { templateId } = useTemplate();
  
  // 根据模板ID选择对应组件，默认使用经典模板
  const TemplateComponent = templateComponents[templateId as keyof typeof templateComponents] || ClassicListingDetail;
  
  return <TemplateComponent />;
}
